import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatNumber(num, decimals = 2) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toFixed(decimals);
}

export function formatPercent(num) {
  const sign = num >= 0 ? '+' : '';
  return `${sign}${num.toFixed(2)}%`;
}

export function formatHours(hours) {
  if (hours < 24) return `${Math.round(hours)}h`;
  const days = Math.floor(hours / 24);
  return `${days}d ${Math.round(hours % 24)}h`;
}

export function getStatusColor(status) {
  const colors = {
    incubating: 'status-incubating',
    testing: 'status-testing',
    scaling: 'status-scaling',
    profitable: 'status-profitable',
    unstable: 'status-unstable',
    killed: 'status-killed',
    archived: 'status-archived',
  };
  return colors[status] || 'status-archived';
}

export function getCategoryIcon(category) {
  const icons = {
    ecommerce: 'ShoppingCart',
    content: 'FileText',
    trading: 'TrendingUp',
    digital_product: 'Package',
    outreach: 'Users',
  };
  return icons[category] || 'Bot';
}
